import axios from 'axios';

export function urlBase64ToUint8Array (base64String) {
	const padding = '='.repeat((4 - base64String.length % 4) % 4);
	const base64 = (base64String + padding)
		.replace(/\-/g, '+')
		.replace(/_/g, '/');
const rawData = window.atob(base64);
	return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

export function extractKey (subscription) {
	const rawKey = subscription.getKey ? subscription.getKey('p256dh') : '';
	return rawKey ? globalThis.btoa(String.fromCharCode.apply(null, new Uint8Array(rawKey))) : '';
}

export function extractAuthSecret (subscription) {
	const rawAuthSecret = subscription.getKey ? subscription.getKey('auth') : '';
	return rawAuthSecret ? globalThis.btoa(String.fromCharCode.apply(null, new Uint8Array(rawAuthSecret))) : '';
}

export async function subscribe (registration) {
	const subscription = await registration.pushManager.subscribe({
		userVisibleOnly: true,
		applicationServerKey: urlBase64ToUint8Array(document.querySelector('meta[name="rapidPubKey"]').content)
	});
	console.log('registration.pushManager.subscribe ok ', subscription);
	const key = extractKey(subscription);
	const authSecret = extractAuthSecret(subscription);
	const { endpoint } = subscription;
	return axios.post('/api/v2/system/user/notifications/subscribe', {
		key,
		authSecret,
		endpoint
	});
}
